import { render } from "./AddonAttributes.vue?vue&type=template&id=1a7e233d"
import script from "./AddonAttributes.vue?vue&type=script&lang=js"
export * from "./AddonAttributes.vue?vue&type=script&lang=js"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__